// Define what styled components base-theme will look like
const theme = {
  colors: {
    primary: '#00bc9b', // green
    secondary: '#2578ca', // blue
    tertiary: '#5128a6', // purple
    quaternary: '#44e584', // green (light)
    quinary: '#ffd977', // orange
    orange: '#ff8c47',
    yellow: '#f3ca19',
    red: '#f07882',
    button: '#ef8124',
    bg: '#2db5ca',
    light: '#F8F1FF',
    dark: '#404040',
    grey1: '#888',
    greyBorder: '#e2e2e2',
    disabled: '#eee',
    white: '#fff',
    transparent: '#ffffff00',
  },
  zIndex: {
    header: '100',
    logo: '110',
    return: '101',
    navToggle: '102',
    overlay: '100',
  },
  gameSelectorWindow: {
    height: '100vh',
    minHeight: '800px',
    width: '100vw',
  },
  gamePanels: {
    portraitWidth: '100vw',
    portraitHeight: '100vh',
    landscapeWidth: '100vw',
    landscapeHeight: '100vh',
  },
  gameThemes: [
    '#6190fa', // blue
    '#fee06c', // yellow
    '#f07882', // red
    '#25ce93', // green
    '#f056e1', // pink
    '#eb9a11', // orange
    '#a32def', // purple
    '#ffec4d', // yellow2
    '#fa2084', // pink2
    '#6190fa', // blue
    '#fee06c', // yellow
  ],
  fonts: {
    baseSize: '13px',
    primary: `'Montserrat', sans-serif`,
  },
  header: {
    height: '75px',
    heightLarge: '85px',
    heightXLarge: '100px',
  },
  nav: {
    bg: '#fff',
  },
  footer: {
    height: '50px',
    heightLarge: '100px',
  },
  logo: {
    duration: '10s',
    strokeWidth: '100px',
    stroke: '#44e584',
    strokeLinecap: 'round',
    width: '25px',
    height: '10px',
  },
  selectorLogo: {
    duration: '10s',
    strokeWidth: '100px',
    stroke: '#5128a6',
    strokeLinecap: 'round',
    width: '8vmin',
    height: '3vmin',
    widthLarge: '5.75vmin',
    heightLarge: '2.2vmin',
  },
  pageWrap: {
    height: '100vh',
    reduceHeight: '200px',
    reduceHeightLG: '300px',
    width: '100vw',
    reduceWidth: '100px',
  },
  gameStats: {
    bg: '#00bc9b',
    borderRadius: '10px',
    boxShadow: '5px 5px 0 rgba(0,0,0,0.1)',
    left: '0',
  },
  game: {
    bg: 'transparent',
    boxShadow: 'none',
  },
  blockContainer: {
    width: '90vmin',
    widthLarge: '100vmin',
    height: '100vmin',
    gap: '15px',
    gapSmall: '5px',
    transition: '1.75s',
    paddingLR: 'calc(20px + 2vmin)',
    maxHeightSM: '310px',
    maxWidthSM: '245px',
    maxHeightMD: '425px',
    maxWidthMD: '365px',
    maxHeightLG: '500px',
    maxWidthLG: '600px',
    maxHeightXL: 'calc(500px + 0.75vmin)',
    maxWidthXL: 'calc(700px + 1.75vmin)',
    maxHeightXXL: 'calc(600px + 0.75vmin)',
    maxWidthXXL: 'calc(850px + 1.75vmin)',
    minHeightLG: '500px',
  },
  result: {
    delay: '2.5s',
  },
  animation: {
    duration: '3.5s',
  },
  block: {
    bg: '#f0f0f0',
    borderColor: '#7e0070',
    borderRadius: '5px',
    borderStyle: 'dotted',
    borderWidth: '0',
    boxShadow: '10px 10px 0 rgba(0,0,0,0.1)',
    hover: '#ffd977',
    selected: '#fec19e',
    targeted: '#5eaefd',
  },
  loading: {
    duration: '2.5s',
    strokeWidth: '50px',
    stroke: '#00bc9b',
    strokeLinecap: 'round',
    width: '60px',
    height: '30px',
  },
  path: {
    strokeWidth: '70px',
    strokeWidthMedium: '60px',
    strokeWidthLarge: '55px',
    stroke: '#7e0070',
    strokeLinecap: 'round',
    width: '85vw',
    height: '90vh',
    maxHeightSM: '360px',
    maxWidthSM: '250px',
    maxHeightMD: '500px',
    maxWidthMD: '410px',
    maxHeightLG: '650px',
    maxWidthLG: '600px',
    maxHeightXL: 'calc(520px + 1vmin)',
    maxWidthXL: 'calc(640px + 1vmin)',
    maxHeightXXL: 'calc(675px + 1vmin)',
    maxWidthXXL: 'calc(800px + 1vmin)',
    minHeightLG: '500px',
  },
  transition: {
    durationShort: '0.1s',
    duration: '0.2s',
    durationLong: '0.5s',
    delay: '0.5s',
    cubicBez: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    easeOut: 'cubic-bezier(0.23, 1, 0.32, 1)',
    easeInOut: 'cubic-bezier(0.86, 0, 0.07, 1)',
    wipe: {
      duration: '0.6s',
      delay: '0.05s',
    },
  },
  breakpoints: {
    sm: '480px',
    md: '768px',
    lg: '960px',
    xl: '1200px',
    xxl: '1441px',
    horz: '960px',
  },
};

export default theme;



// WEBPACK FOOTER //
// ./src/theme/theme.js